
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-[#b8144a] to-[#d91e5b] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">About Peter Akinnubi Apostolic Mandate</h1>
          <p className="text-xl max-w-4xl mx-auto">
            A divine assignment, a global movement, and a prophetic commission to gather the Ecclesia, 
            raise true disciples, and prepare the saints for the return of the King
          </p>
        </div>
      </section>

      {/* Divine Mandate */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">A Mandate from Heaven</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">From Moses to Messiah</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="prose prose-lg text-gray-700">
                <p className="text-xl leading-relaxed mb-6">
                  Peter Akinnubi Apostolic Mandate (PAAM) is not merely a ministry, it is a divine assignment, 
                  a global movement, and a prophetic commission to gather the Ecclesia, raise true disciples, 
                  and prepare the saints for the return of the King.
                </p>
                <p className="text-lg leading-relaxed mb-6">
                  The foundation of PAAM is the heavenly pattern revealed to Apostle Peter O. Akinnubi in a 
                  series of divine encounters, beginning in 1993. In that sacred moment, the Lord declared 
                  that He would use Apostle Peter "like Moses—to gather His people and teach them His way."
                </p>
                <p className="text-lg leading-relaxed">
                  What began as a call became a mandate, and what became a mandate has become a movement—uniting 
                  believers across generations, denominations, and nations under the Lordship of Christ.
                </p>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Divine%20heavenly%20vision%20with%20golden%20light%20rays%20breaking%20through%20clouds%2C%20spiritual%20revelation%20scene%20with%20Moses-like%20figure%20receiving%20divine%20commission%2C%20prophetic%20calling%20atmosphere%20with%20sacred%20mountain%20backdrop%2C%20representing%20apostolic%20mandate%20from%20heaven%20with%20warm%20golden%20lighting%20and%20spiritual%20depth&width=600&height=500&seq=divine-mandate-1&orientation=landscape"
                alt="Divine Mandate from Heaven"
                className="rounded-lg shadow-2xl object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Apostle Peter Akinnubi */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/0f4196e35f78d87056a996d208b7f641/10437a960a01189954d6772fe2c1a766.jpeg"
                alt="Apostle Peter Akinnubi"
                className="rounded-lg shadow-2xl object-cover w-full h-96"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Apostle Peter O. Akinnubi</h2>
              <div className="prose prose-lg text-gray-700">
                <p className="text-xl leading-relaxed mb-6">
                  Called by God in June 1993, Apostle Peter Akinnubi has been faithfully serving 
                  the body of Christ for over three decades, establishing a global network of 
                  believers united in the doctrine of Christ.
                </p>
                <p className="text-lg leading-relaxed mb-6">
                  The spiritual blueprint of PAAM is prophetically captured in the message 
                  "From Moses to Messiah"—a Christocentric framework that connects the shadow 
                  of the Old Covenant to the fullness of Christ in the New.
                </p>
                <p className="text-lg leading-relaxed">
                  Through this lens, PAAM teaches, trains, and transforms with clarity, power, 
                  and apostolic fire, serving as the Presiding International President alongside 
                  Pastor Mrs. Clementina Akinnubi as Director of Welfare and Family Affairs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nine Strategic Programs */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Nine Strategic Programs</h2>
            <p className="text-xl text-gray-600">A Global Apostolic Engine</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-group-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Christ Family Network (CFN)</h3>
              <p className="text-gray-700 text-center">
                Small group teaching and prayer centers planted across cities, towns, and nations
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-follow-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">One Fold Network</h3>
              <p className="text-gray-700 text-center">
                A global discipleship network raising sons and daughters through intentional spiritual formation
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-church-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Ecclesia of Believers International (EBI)</h3>
              <p className="text-gray-700 text-center">
                Apostolic churches and assemblies under one doctrine and spiritual oversight
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">All Believers International Convention (ABIC)</h3>
              <p className="text-gray-700 text-center">
                Annual global apostolic summit gathering saints from every nation
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-seedling-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Root and Reign Mission</h3>
              <p className="text-gray-700 text-center">
                Rural and unreached people mission arm, raising firebrands in dry lands
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-pulse-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Meal and Medical Mission</h3>
              <p className="text-gray-700 text-center">
                Ministry of healing, compassion, and economic empowerment for the poor and vulnerable
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Gallery of Revelation Network</h3>
              <p className="text-gray-700 text-center">
                Library, Publishing, Christian education, doctrine manuals, and training for Bible colleges
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-megaphone-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Christ Gospel Crusade (CGC)</h3>
              <p className="text-gray-700 text-center">
                Annual, simultaneous global evangelistic campaigns under one message and one banner
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-community-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Jesus Christ Rally (JCR)</h3>
              <p className="text-gray-700 text-center">
                Community street evangelism and altar of worship movement across territories
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What Makes PAAM Distinct */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">What Makes PAAM Distinct</h2>
            <p className="text-xl text-gray-600">A divine order, a prophetic gathering, a Kingdom commission</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-cross-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Christocentric Doctrine</h3>
              <p className="text-gray-700">
                Every teaching and training flows from the finished work of Christ and the doctrine of the apostles
              </p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-organization-chart text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Spiritual Structure</h3>
              <p className="text-gray-700">
                Apostolic councils and coordinated networks ensure order, integrity, and accountability across nations
              </p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Discipleship-Driven</h3>
              <p className="text-gray-700">
                We raise people, not platforms, forming Saints, not just movements
              </p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-mark-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Scriptural Alignment</h3>
              <p className="text-gray-700">
                From Moses to Messiah, every revelation is grounded in Scripture and interpreted through Christ
              </p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-earth-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Global Reach, Local Impact</h3>
              <p className="text-gray-700">
                From major cities to rural villages, PAAM equips believers to manifest the Kingdom wherever they are
              </p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-scales-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Grace and Truth</h3>
              <p className="text-gray-700">
                We uphold the balance of apostolic truth with the mercy of the Cross
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Focus Statement */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-8">Our Focus</h2>
          <blockquote className="text-2xl font-light italic mb-8 max-w-4xl mx-auto">
            "To gather, ground, and send believers in the doctrine of Christ, raising a prepared people for the coming King."
          </blockquote>
          <p className="text-xl max-w-4xl mx-auto">
            We exist to call out the Church from religious confusion, disciple the saints in apostolic truth, 
            and mobilize the body of Christ to labor in the harvest fields of the world, not by human ambition, 
            but by the power of revelation and the operation of grace.
          </p>
        </div>
      </section>

      {/* Digital Hub */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Digital Hub</h2>
            <p className="text-xl text-gray-600">The Apostolic Gate to the Nations</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <i className="ri-graduation-cap-line text-[#b8144a] text-3xl mb-3"></i>
              <h4 className="font-semibold text-gray-900 mb-2">Training Programs</h4>
              <p className="text-sm text-gray-600">Access digital courses and apostolic education</p>
            </div>

            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <i className="ri-group-line text-[#b8144a] text-3xl mb-3"></i>
              <h4 className="font-semibold text-gray-900 mb-2">Join CFN Center</h4>
              <p className="text-sm text-gray-600">Connect with local Christ Family Network</p>
            </div>

            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <i className="ri-hand-heart-line text-[#b8144a] text-3xl mb-3"></i>
              <h4 className="font-semibold text-gray-900 mb-2">Partnership</h4>
              <p className="text-sm text-gray-600">Support through giving and sponsorship</p>
            </div>

            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <i className="ri-calendar-event-line text-[#b8144a] text-3xl mb-3"></i>
              <h4 className="font-semibold text-gray-900 mb-2">Events</h4>
              <p className="text-sm text-gray-600">Join crusades, conventions, and conferences</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
